<template>
  <b-col cols="6">
    <h6>{{ header }}</h6>
    <p>{{ message }}</p>
    <ul>
      <li
        v-for="item in showLessList"
        :key="item"
      >
        {{ item }}
      </li>
      <li
        v-for="item in showMoreList"
        :key="item"
      >
        {{ item }}
      </li>
    </ul>
  </b-col>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import { MINIMAL_LENGTH_LIST } from '@/constants'

const props = {
  header: {
    type: String,
    default: '',
  },
  message: {
    type: String,
    default: '',
  },
  list: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
  showMore: {
    type: Boolean,
    default: false,
  },
}

@Component
export default class ValidateWarningList extends Vue.extend({ props }) {
  get showLessList () {
    if (!this.showMore && this.list.length > MINIMAL_LENGTH_LIST) return this.list.slice(0, MINIMAL_LENGTH_LIST).concat('...')
    else return this.list.slice(0, MINIMAL_LENGTH_LIST)
  }

  get showMoreList () {
    if (this.showMore && this.list.length > MINIMAL_LENGTH_LIST) return this.list.slice(MINIMAL_LENGTH_LIST)
    else return []
  }
}

</script>
